import { render } from "./Compact.vue?vue&type=template&id=1fcf22b8"
import script from "./Compact.vue?vue&type=script&lang=js"
export * from "./Compact.vue?vue&type=script&lang=js"

import "./Compact.vue?vue&type=style&index=0&id=1fcf22b8&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__